// dropdownOptions.ts
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Flag from 'react-world-flags';

import { TOP_LANGUAGES } from '@/features/components/LANGUAGES_FLAGS';
import CrownIcon from '@/features/Icons/CrownIcon'; // Adjust import based on your file structure



export const toneOptions = (intl: any, premium: boolean) => {
  return [
    { value: 'formal', label: <FormattedMessage id="home.text-generator.tone.formal" /> },
    { value: 'casual', label: <FormattedMessage id="home.text-generator.tone.casual" /> },
    { value: 'playful', label: <FormattedMessage id="home.text-generator.tone.playful" /> },
    { value: 'serious', label: <FormattedMessage id="home.text-generator.tone.serious" /> },
    { value: 'humorous', label: <FormattedMessage id="home.text-generator.tone.humorous" /> },
    {
      value: 'custom',
      label: <FormattedMessage id="home.text-generator.tone.custom" />,
      isPremium: true,
      tooltip: <FormattedMessage id="home.text-generator.tone.custom.tooltip" />,
      icon: <CrownIcon />
    }
  ];
};

export const lengthOptions = (intl: any) => {
  return [
    { value: 'shorter', label: <FormattedMessage id="home.text-generator.length.shorter" /> },
    { value: 'same', label: <FormattedMessage id="home.text-generator.length.same" /> },
    { value: 'longer', label: <FormattedMessage id="home.text-generator.length.longer" /> }
  ];
};


